import React, {memo} from 'react'
import images from '../assets/images'

const Loader = () => (
  <div className="divLoader">
    <img src={images.loader} className="svgLoader" alt="loader" />
  </div>
)
export default memo(Loader)
